// ThreadView barrel 의 default 분기 결정 helper.
//
// barrel ([./index.tsx](./index.tsx)) 가 InnerViewer / IFrameViewer 양 클래스 default
// import 와 함께 본 helper 를 사용. 본 파일은 viewer 클래스 import 없이 독립 — 단위
// 테스트 가능 (DataManager / popups 등 transitive 의존을 회피).

// mobile WebView (iOS / Android native app) 감지. OfficeMail user-agent 검사는
// packages/email-thread-viewer/src/helper/mailview.ts 의 isOfficeMailApp() 와 동일 로직.
// host 측 인라인 — packages 의존 회피.
export function isMobileApp(): boolean {
  return window.navigator.userAgent.indexOf('OfficeMail') >= 0
}

// 양산 escape hatch — localStorage 의 `__forceIFrameViewer = 'true'` 가 설정되면
// InnerViewer 비활성 (IFrameViewer 강제). SSR / private mode 등의 localStorage 접근
// 실패는 try/catch 로 false fallback.
export function isForcedIFrameViewer(): boolean {
  try {
    return window.localStorage.getItem('__forceIFrameViewer') === 'true'
  } catch {
    return false
  }
}

// OMD-237 대칭 escape hatch — localStorage 의 `__forceInnerViewer = 'true'` 가 설정되면
// desktop 에서 InnerViewer 강제 (iframe 기본 전환 후 롤백 경로). mobile WebView 와
// `__forceIFrameViewer` 는 iframe 을 우선하므로 본 값보다 우선한다 (barrel 분기 참조).
// localStorage 접근 실패는 try/catch 로 false fallback.
export function isForcedInnerViewer(): boolean {
  try {
    return window.localStorage.getItem('__forceInnerViewer') === 'true'
  } catch {
    return false
  }
}
